/**
 * Host glue between the Sanctions Screening tab and the Loan Detail header chip.
 *
 * - `notifyOfacHeaderStatus` — apply loan_status from roll-up (no extra POST).
 * - `notifyOfacHeaderRefresh` — re-read POST /bff/ofac/status after mutations
 *   that may not have pushed a status yet (e.g. Bridger FP status_refreshed).
 */

import type { LoanStatus } from "./initiatePurchaseOfac";

type RefreshListener = () => void;
type StatusListener = (status: LoanStatus) => void;

const refreshListeners = new Set<RefreshListener>();
const statusListeners = new Set<StatusListener>();

export function subscribeOfacHeaderRefresh(listener: RefreshListener): () => void {
  refreshListeners.add(listener);
  return () => {
    refreshListeners.delete(listener);
  };
}

export function notifyOfacHeaderRefresh(): void {
  refreshListeners.forEach((listener) => listener());
}

export function subscribeOfacHeaderStatus(listener: StatusListener): () => void {
  statusListeners.add(listener);
  return () => {
    statusListeners.delete(listener);
  };
}

/** Push roll-up / known status into the header chip — skips POST /bff/ofac/status. */
export function notifyOfacHeaderStatus(status: LoanStatus): void {
  statusListeners.forEach((listener) => listener(status));
}

/** Test-only: drop all subscribers. */
export function resetOfacHeaderRefreshSubscribers(): void {
  refreshListeners.clear();
  statusListeners.clear();
}
